

























































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import PartnershipSteps from '@ui/AudienceSetWizard/PartnershipStep/PartnershipSteps'
import AudienceAvailabilityList from '@ui/AudienceSetWizard/components/AudienceAvailabilityList'
import Modal from '@components/Modal'
import PartnershipDemographicsForm from './PartnershipDemographicsForm'

settings =
  name: 'PartnershipDemographicsStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      PartnershipSteps,
      AudienceAvailabilityList,
      Modal,
      PartnershipDemographicsForm,
    }

    data: ->
      allSelected: false
      selectedAudienceAvailabilityKeys: []
      demographicsModal:
        show: false
        audienceAvailabilityKeys: []
        audienceDemographics: null

    computed:
      audienceAvailabilities: -> @wizard.audienceSetData.audience_availabilities
      hasAudienceAvailabilitiesSelected: -> @selectedAudienceAvailabilityKeys.length > 0

    methods:
      hiToggleAllSelected: (checked) ->
        if checked
          @selectedAudienceAvailabilityKeys = @audienceAvailabilities.map((item) -> item.key)
        else
          @selectedAudienceAvailabilityKeys = []

      hiBulkSetDemographics: ->
        @demographicsModal =
          show: true
          audienceAvailabilityKeys: @selectedAudienceAvailabilityKeys
          audienceDemographics:
            age: {}
            ethnicity: {}
            gender: {}

      hiSetDemographics: (audienceAvailability) ->
        @demographicsModal =
          show: true
          audienceAvailabilityKeys: [audienceAvailability.key]
          audienceDemographics: audienceAvailability.audience_demographics

      hiCloseDemographicsModal: ->
        @closeDemographicsModal()

      hiSaveDemographicsModal: ->
        for key in @demographicsModal.audienceAvailabilityKeys
          audienceAvailability = @audienceAvailabilities.find((item) => item.key is key)
          audienceAvailability.audience_demographics = @demographicsModal.audienceDemographics
        @wizard.syncAndSave()
        @closeDemographicsModal()

      closeDemographicsModal: ->
        @demographicsModal.show = false
        @clearSelectedAudienceAvailabilities()

      clearSelectedAudienceAvailabilities: ->
        @selectedAudienceAvailabilityKeys = []

      getSelectedAudienceAvailabilities: ->
        @audienceAvailabilities.filter((item) => item.key in @selectedAudienceAvailabilityKeys)

      audienceAvailabilityHasDemographics: (audienceAvailability) ->
        for key, value  of audienceAvailability.audience_demographics
          return true if Object.values(value).length
        false

    watch:
      selectedAudienceAvailabilityKeys: ->
        @allSelected = @selectedAudienceAvailabilityKeys.length is @audienceAvailabilities.length

export default VueOptions.vue settings
